module.exports = __webpack_public_path__ + "static/media/circle-close.d38ab2c8.svg";